var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UuiFlexlayout, UuiSpinner } from '@aonunited/react';
import AonPannel from '../../components/core/AonPannel';
import React, { useEffect, useState } from 'react';
import { AonButton } from '../../components/core/AonButton';
import { BUTTON_VARIANT } from '../../components/core/AonButton/consts';
import { getMarketInfo } from '../../api/marketData/getMarketInfo';
import { getMarketProfileData } from '../../api/marketData/marketProfileData';
import { getGroupProfileData } from '../../api/marketData/groupProfileData';
import { useClientPageStore, useErrorStore, useMarketDetailsStore } from '../../store';
import { useNavigate } from 'react-router-dom';
import { getApplicationConfig } from '../../constants/utilities';
import { postMarketFactSheet } from '../../api/marketData/marketFactSheetsData';
export var MarketDetailsPan = function (Props) {
    var appConfig = getApplicationConfig();
    var _a = useState(false), loader = _a[0], setLoader = _a[1];
    var _b = useState(false), error = _b[0], setError = _b[1];
    var clientstore = useClientPageStore();
    var errorStore = useErrorStore();
    var navigate = useNavigate();
    var marketDetailsStore = useMarketDetailsStore();
    var marketIdArray = [5, 6, 7, 8, 9, 10];
    var _c = useState({
        column_one: [],
        column_two: [],
        column_three: [],
    }), marketDetailsData = _c[0], setMarketdetailsData = _c[1];
    var DownLoadPDF = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, clientstore.handlePdfDownload(value)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    errorStore.showError({ message: "Error", code: "500" });
                    navigate('/error');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var fetchMarketDetailsData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isGuideAndPreview, marketDetailsResponse, marketProfileData, c_one, c_two, c_three, value, groupProfileRes, factSheetResponse_1, allKeys, _i, allKeys_1, objectKey, keys, error_2;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    isGuideAndPreview = appConfig.applicationId === 3 || appConfig.applicationId === 1;
                    if (!Props.id) return [3 /*break*/, 10];
                    _j.label = 1;
                case 1:
                    _j.trys.push([1, 9, , 10]);
                    setLoader(true);
                    marketDetailsStore.setIntermediaries([]);
                    marketDetailsStore.setAdditionalInfo("");
                    return [4 /*yield*/, getMarketInfo({ MarketId: Props.id })];
                case 2:
                    marketDetailsResponse = _j.sent();
                    if (!marketDetailsResponse.data.applicableToMarketFlag) {
                        setLoader(false);
                        return [2 /*return*/]; // No need to excute further
                    }
                    marketProfileData = undefined;
                    if (!!marketIdArray.includes(marketDetailsResponse.data.marketTypeId)) return [3 /*break*/, 4];
                    return [4 /*yield*/, getMarketProfileData({ MarketIds: Props.id.toString() })];
                case 3:
                    marketProfileData = _j.sent();
                    _j.label = 4;
                case 4:
                    c_one = [];
                    c_two = [];
                    c_three = [];
                    value = marketDetailsResponse.data.fields;
                    groupProfileRes = undefined;
                    if (!(value.GroupProfile.applicableToMarketFlag && !marketIdArray.includes(marketDetailsResponse.data.marketTypeId))) return [3 /*break*/, 6];
                    return [4 /*yield*/, getGroupProfileData({ MarketGroupGuid: value.MarketGroupGuid.value })];
                case 5:
                    groupProfileRes = _j.sent();
                    _j.label = 6;
                case 6:
                    factSheetResponse_1 = undefined;
                    if (!isGuideAndPreview) return [3 /*break*/, 8];
                    return [4 /*yield*/, postMarketFactSheet({ MarketIds: Props.id.toString() })];
                case 7:
                    factSheetResponse_1 = _j.sent();
                    _j.label = 8;
                case 8:
                    allKeys = Object.keys(value);
                    if (marketDetailsResponse.data.marketId) {
                        c_two.push({
                            name: "Aon Id",
                            value: marketDetailsResponse.data.marketId.toString()
                        });
                    }
                    for (_i = 0, allKeys_1 = allKeys; _i < allKeys_1.length; _i++) {
                        objectKey = allKeys_1[_i];
                        keys = objectKey;
                        if ((_a = (value[keys])) === null || _a === void 0 ? void 0 : _a.applicableToMarketFlag) {
                            if (keys === "Name") {
                                c_one.push({
                                    name: "Legal Name",
                                    value: value[keys].value
                                });
                            }
                            else if (keys === "GroupName") {
                                c_one.push({
                                    name: "Group Name",
                                    value: value[keys].value
                                });
                            }
                            else if (keys === "FormerName") {
                                c_one.push({
                                    name: "Former Name",
                                    value: value[keys].value
                                });
                            }
                            else if (keys === "DomicileCountryName") {
                                c_one.push({
                                    name: "Country of Domicile",
                                    value: value[keys].value
                                });
                            }
                            else if (keys === "DomicileStateName") {
                                c_one.push({
                                    name: "State of Domicile",
                                    value: value[keys].value
                                });
                            }
                            else if (keys === "Address") {
                                c_one.push({
                                    name: "Address",
                                    value: "",
                                    element: React.createElement("div", null,
                                        React.createElement("div", null, (_c = (_b = value[keys]) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.street),
                                        React.createElement("div", null, (_e = (_d = value[keys]) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e.city))
                                });
                            }
                            else if (keys === "NAIC") {
                                c_two.push({
                                    name: "NAIC Code",
                                    value: value[keys].value
                                });
                            }
                            else if (keys === "FeinAA") {
                                c_two.push({
                                    name: "FEIN/AIIN",
                                    value: value[keys].value
                                });
                            }
                            else if (keys === "LEICode") {
                                c_two.push({
                                    name: "LEI Code",
                                    value: value[keys].value
                                });
                            }
                            else if (keys === "WebAddress") {
                                c_two.push({
                                    name: "Website",
                                    value: value[keys].value,
                                    element: value[keys].value ? React.createElement("a", { style: { fontWeight: "bold", color: "#007585", cursor: "pointer" }, href: "https://" + value[keys].value, target: '_blank' }, value[keys].value) : React.createElement(React.Fragment, null)
                                });
                            }
                            else if (keys === "AnalystName") {
                                c_three.push({
                                    name: "Aon Analyst",
                                    value: value[keys].value
                                });
                            }
                            else if (keys === "Intermediaries") {
                                marketDetailsStore.setIntermediaries(value[keys].value);
                            }
                            else if (keys === "AdditionalInfoFreeFormNarrative") {
                                marketDetailsStore.setAdditionalInfo(value[keys].value);
                            }
                        }
                    }
                    if (!marketIdArray.includes(marketDetailsResponse.data.marketTypeId)) {
                        c_three.push({
                            name: isGuideAndPreview ? "Fact Sheet" : "Market Profile(s)",
                            value: "",
                            element: isGuideAndPreview ?
                                ((_g = (_f = factSheetResponse_1 === null || factSheetResponse_1 === void 0 ? void 0 : factSheetResponse_1.data) === null || _f === void 0 ? void 0 : _f.value[0]) === null || _g === void 0 ? void 0 : _g.documentGuid) ? React.createElement("div", null,
                                    React.createElement("div", { style: { marginBlock: "8px", fontWeight: "bold", color: "#007585", cursor: "pointer" }, onClick: function () { var _a, _b; return DownLoadPDF((_b = (_a = factSheetResponse_1 === null || factSheetResponse_1 === void 0 ? void 0 : factSheetResponse_1.data) === null || _a === void 0 ? void 0 : _a.value[0]) === null || _b === void 0 ? void 0 : _b.documentGuid); } }, "Fact Sheet")) : null
                                : React.createElement("div", null, ((_h = marketProfileData === null || marketProfileData === void 0 ? void 0 : marketProfileData.data) === null || _h === void 0 ? void 0 : _h.value).slice(0, 5).map(function (item, index) {
                                    return React.createElement("div", { key: index, style: { marginBlock: "8px", fontWeight: "bold", color: "#007585", cursor: "pointer" }, onClick: function () { return DownLoadPDF(item.documentGUId); } }, item.yearQuarter);
                                }))
                        });
                        c_three.push({
                            name: "Group Profile(s)",
                            value: "",
                            element: React.createElement("div", null, groupProfileRes === null || groupProfileRes === void 0 ? void 0 : groupProfileRes.data.value.slice(0, 5).map(function (item, index) {
                                return React.createElement("div", { key: index, style: { marginBlock: "8px", fontWeight: "bold", color: "#007585", cursor: "pointer" }, onClick: function () { return DownLoadPDF(item.documentGUId); } }, item.yearQuarter);
                            }))
                        });
                    }
                    c_three.push({
                        name: "Other Attachments(s)",
                        value: "",
                        element: React.createElement("div", null, value === null || value === void 0 ? void 0 : value.MarketOtherAttachment.value.map(function (item, index) {
                            return React.createElement("div", { key: index, style: { marginBlock: "8px", fontWeight: "bold", color: "#007585", cursor: "pointer" }, onClick: function () { return DownLoadPDF(item.documentGuid); } }, item.description);
                        }))
                    });
                    setMarketdetailsData({ column_one: c_one, column_two: c_two, column_three: c_three });
                    setLoader(false);
                    return [3 /*break*/, 10];
                case 9:
                    error_2 = _j.sent();
                    setError(false);
                    console.log("error", error_2);
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchMarketDetailsData();
    }, []);
    var MarketDetailsBody = function () {
        return (React.createElement(UuiFlexlayout, { direction: "row", gap: "lg" },
            loader ? React.createElement(UuiSpinner, { style: { marginLeft: "50%" }, variant: "small" }) : React.createElement(React.Fragment, null,
                React.createElement("div", { className: "one-third-width" }, marketDetailsData.column_one.map(function (data, index) {
                    return React.createElement("div", { key: index, style: { padding: "12px", } },
                        React.createElement("div", { key: index + 1, style: { marginBottom: "7px", color: "grey" }, children: data.name }),
                        data.element ? data.element : React.createElement("span", { key: index + 2, style: { marginTop: "5px", marginInline: "auto" } }, data.value));
                })),
                React.createElement("div", { className: "one-third-width" },
                    " ",
                    marketDetailsData.column_two.map(function (data, index) {
                        return React.createElement("div", { key: index, style: { padding: "12px", } },
                            React.createElement("div", { key: index + 1, style: { marginBottom: "7px", color: "grey" }, children: data.name }),
                            data.element ? data.element : React.createElement("span", { key: index + 2, style: { marginTop: "5px", marginInline: "auto" } }, data.value));
                    })),
                React.createElement("div", { className: "one-third-width" },
                    " ",
                    marketDetailsData.column_three.map(function (data, index) {
                        return React.createElement("div", { key: index, style: { padding: "12px", } },
                            React.createElement("div", { key: index + 1, style: { marginBottom: "7px", color: "grey" }, children: data.name }),
                            data.element ? data.element : React.createElement("span", { key: index + 2, style: { marginTop: "5px", marginInline: "auto" } }, data.value));
                    }))),
            error && React.createElement("div", null,
                React.createElement(AonButton, { style: { marginLeft: "50%" }, variant: BUTTON_VARIANT.TEXT, onClick: function () { return fetchMarketDetailsData(); } }, "Retry"))));
    };
    return React.createElement(AonPannel, { headerTitle: "Market Detail", Body: React.createElement(MarketDetailsBody, null) });
};
